import { AgentBookingModel } from '@/__generated';
import { DATE_TIME_DISPLAY_FORMAT, appDisplayDateFormat } from '@/config';
import { BookingStatus } from '@/constants';
import { formatPriceWithCurrency } from '@/hooks/useCurrencyFormat';
import moment from 'moment';
import React from 'react';
import PriceOrTBA from './PriceOrTBA';

type Props = {
  booking: AgentBookingModel;
  fromPage: 'Failed' | 'Cancelled-Failed' | 'Cancelled-Success' | 'Success' | 'Need2Check';
};

export default function BookingCompletedHeaderInfo({ booking, fromPage }: Props) {
  const price = React.useMemo(() => {
    if (booking.onHold) {
      if (['Failed', 'Cancelled-Failed'].includes(fromPage)) {
        return 0;
      }
    }

    return booking.sellingPrice;
  }, [booking]);
  const displayPrice = React.useMemo(() => {
    if (booking.onHold) {
      if (['Cancelled-Failed'].includes(fromPage)) {
        return false;
      }
    }

    return true;
  }, [booking]);

  const displayOnHoldDeadline = React.useMemo(() => {
    if (booking.onHold) {
      if (['Failed', 'Cancelled-Failed', 'Cancelled-Success'].includes(fromPage)) {
        return false;
      }
    }
    return [BookingStatus.Hold, BookingStatus.PartialHold].includes(booking.bookingStatus as any);
  }, [booking]);
  return (
    <div className="border-type-1 rounded-8 px-50 py-35 mt-40">
      <div className="row x-gap-10 y-gap-10">
        <div className="col-lg-3 col-md-6">
          <div className="text-15 lh-12">Booking Number</div>
          <div className="text-15 lh-12  fw-500 text-blue-1 mt-10 text-18">{booking.refNumber}</div>
        </div>
        {/* End .col */}
        <div className="col-lg-3 col-md-6 col-6">
          <div className="text-15 lh-12">Date</div>
          <div className="text-15 lh-12 fw-500 text-blue-1 mt-10 text-18">{appDisplayDateFormat.default.dateOnly(booking.createdAt)}</div>
        </div>
        {/* End .col */}
        {displayPrice ? (
          <div className="col-lg-3 col-md-6 col-6">
            <div className="text-15 lh-12">Total price</div>
            <div className="text-15 lh-12 fw-500 text-blue-1 mt-10 text-18">
              <PriceOrTBA
                cancelledAt={booking.hotel?.rooms?.find(x => x.cancelledAt)?.cancelledAt}
                currency={booking.currency}
                faCancelChargeDate={booking.faCancelChargeDate}
                price={booking.sellingPrice}
                source={booking.source}
              />
            </div>
          </div>
        ) : null}

        {/* End .col */}
        {displayOnHoldDeadline ? (
          <div className="col-lg-3 col-12">
            <div className="text-15 lh-12">On hold payment deadline (JST)</div>
            <div className="text-15 lh-12 fw-500 text-blue-1 mt-10 text-18">
              {appDisplayDateFormat.default.withJstDateTime(booking.onHoldPaymentDeadline)}
            </div>
          </div>
        ) : (
          <div className="col-lg-3 col-12">
            <div className="text-15 lh-12">Order ID</div>
            <div className="text-15 lh-12 fw-500 text-blue-1 mt-10 text-18">{booking.orderId}</div>
          </div>
        )}

        {/* End .col */}
      </div>
    </div>
  );
}
